import {
  type Document,
  type DocumentSite,
  type MissingDocument,
} from '@/modules/documents/domain/entities/document';
import { DocumentType } from '@/modules/documents/domain/entities/document-type';

import { FeApi } from '../../fetch-client';

type ApiTypeData = 'Other' | 'Specifications' | 'Presentations' | 'Reports';

const typeMapper: Record<ApiTypeData, DocumentType> = {
  Other: DocumentType.OTHER,
  Specifications: DocumentType.SPECIFICATIONS,
  Presentations: DocumentType.PRESENTATIONS,
  Reports: DocumentType.REPORTS,
};

export function documentMapper(
  data: FeApi.DocumentListViewOutputSerializerDocumentRead,
): Document {
  return {
    id: data.uuid,
    required: data.required,
    name: data.name,
    type: typeMapper[data.type],
    tags: data.tags.map((tag) => tag.title),
    updatedAt: new Date(data.modified_at),
    uploadedBy: {
      displayName: data.created_by,
      isAccure: data.created_by === 'ACCURE',
    },
    file: {
      name: data.file.file_name,
      extension: data.file.file_extension,
    },
    sites: data.sites.map(documentSiteMapper),
    isGlobal: data.is_global,
  };
}

export function missingDocumentMapper(
  data: FeApi.DocumentListViewOutputSerializerMissingDocuments,
): MissingDocument {
  return {
    id: data.name,
    name: data.name,
    tags: data.tags,
    type: typeMapper[data.type],
    sites: data.sites.map(documentSiteMapper),
  };
}

function documentSiteMapper({
  accure_id,
  name,
}: FeApi.SiteDocumentList): DocumentSite {
  return { siteId: accure_id, name };
}
